import React from "react";
import AddOn from "./addOn";
class AddOnParent extends React.Component {
    render() {
        return <AddOn />;
    }
}


export default AddOnParent;